import { makeStyles, createStyles } from '@material-ui/core'

export const useDesktopStyles = makeStyles(
  (theme) =>
    createStyles({
      root: {
        position: 'fixed',
        top: 0,
        width: '100vw',
        zIndex: 999,

        backgroundColor: theme.palette.bg.headerBg,
        boxShadow: '0px 4px 12px rgba(209, 212, 226, 0.4)'
      },

      container: {
        height: 74,
        alignItems: 'center',
        justifyContent: 'space-between'
      },

      links: {
        display: 'flex',
        padding: '0 50px',

        '& > a:not(:last-child)': {
          marginRight: theme.spacing(6)
        }
      },

      formControl: {
        margin: theme.spacing(1),
        minWidth: 80
      },

      selectEmpty: {
        marginTop: theme.spacing(2)
      }
    }),
  {
    name: 'HeaderDesktop'
  }
)

export const useMobileStyles = makeStyles(
  (theme) =>
    createStyles({
      root: {
        position: 'fixed',
        top: 0,
        width: '100%',
        backgroundColor: theme.palette.bg.headerBg,
        boxShadow: '0px 4px 12px rgba(209, 212, 226, 0.4)',
        zIndex: 1301
      },

      container: {
        padding: '0px 3px 0px 15px',
        minHeight: 64,
        alignItems: 'center',
        justifyContent: 'space-between'
      },

      logo: {
        [theme.breakpoints.down('sm')]: {
          height: 40
        }
      },

      header: {
        borderBottom: `1px solid ${theme.palette.text.disabled}`
      },

      paper: {
        width: '100%'
      },

      modal: {
        zIndex: ('1302 !important' as unknown) as number
      },

      tabItem: {
        position: 'relative',
        padding: 0,

        '& > *': {
          padding: '12.5px 20px',
          width: '100%',

          '& p': {
            fontWeight: 600
          }
        }
      },

      link: {
        fontWeight: 600,
        fontSize: 16,

        '&.active': {
          color: theme.palette.primary.main
        },

        '&:hover': {
          textDecoration: 'underline'
        }
      },

      linksWrapper: {
        padding: '17.5px 0',
        borderBottom: `1px solid ${theme.palette.text.disabled}`
      },

      btnsWrapper: {
        margin: theme.spacing(3, 2),

        '& > *:not(:last-child)': {
          marginBottom: theme.spacing(1)
        }
      },

      logOut: {
        backgroundColor: theme.palette.grey[100]
      },

      notification: {
        overflow: 'visible',

        '& p': {
          position: 'relative',

          '&::after': {
            content: '""',
            position: 'absolute',
            left: -9,
            top: 0,
            width: 6,
            height: 6,
            backgroundColor: theme.palette.warning.main,
            borderRadius: '50%'
          }
        }
      }
    }),
  { name: 'HeaderMobile' }
)
